import jsCookie from 'js-cookie';
import { authUrl } from './env';

/**
 * web 登录
 * !important 业务中尽量直接使用login
 */
export function login(getUrl?: () => string) {
  const org = jsCookie.get('org');
  const p = org ? 'org' : '';
  const s = org ? `org=${org}&` : '';
  const loginUrl = `${authUrl}${p}?${s}redirect_uri=${btoa(getUrl ? getUrl() : window.location.href)}`;
  // window.location.replace(loginUrl);
  window.location.href = loginUrl;
}
